var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99957 12.9021C10.9351 12.9021 11.6934 12.1436 11.6934 11.2078C11.6934 10.2721 10.9351 9.51355 9.99957 9.51355C9.06407 9.51355 8.3057 10.2721 8.3057 11.2078C8.3057 12.1436 9.06407 12.9021 9.99957 12.9021Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99964 5.48474C11.1313 5.48474 12.2376 5.8204 13.1785 6.44928C14.1195 7.07816 14.8529 7.97202 15.286 9.0178C15.719 10.0636 15.8324 11.2144 15.6116 12.3246C15.3908 13.4348 14.8458 14.4545 14.0456 15.255C13.2454 16.0554 12.2259 16.6005 11.1159 16.8213C10.006 17.0421 8.85551 16.9288 7.80997 16.4956C6.76444 16.0624 5.8708 15.3289 5.24207 14.3877C4.61335 13.4465 4.27776 12.34 4.27776 11.208C4.27948 9.69063 4.88288 8.23589 5.95556 7.16295C7.02825 6.09 8.48263 5.48646 9.99964 5.48474ZM9.99964 15.3052C10.8098 15.3052 11.6018 15.0649 12.2754 14.6147C12.949 14.1645 13.474 13.5246 13.784 12.7759C14.0941 12.0273 14.1752 11.2035 14.0171 10.4087C13.8591 9.6139 13.469 8.88385 12.8961 8.31085C12.3232 7.73784 11.5934 7.34762 10.7988 7.18953C10.0042 7.03144 9.18058 7.11258 8.43209 7.42269C7.68361 7.73279 7.04387 8.25794 6.59377 8.93172C6.14367 9.6055 5.90344 10.3977 5.90344 11.208C5.90466 12.2943 6.33662 13.3357 7.10454 14.1038C7.87246 14.8719 8.91364 15.304 9.99964 15.3052Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99959 17.4416C4.6882 17.4416 0.53379 11.9274 0.359355 11.6926L0 11.2079L0.359761 10.7233C0.534033 10.4886 4.68844 4.97418 10 4.97418C15.3116 4.97418 19.4659 10.4885 19.6402 10.7233L20 11.2079L19.6402 11.6926C19.4655 11.9274 15.3111 17.4416 9.99959 17.4416ZM2.05989 11.2079C3.14828 12.4807 6.34898 15.8156 9.99959 15.8156C13.6613 15.8156 16.8547 12.4815 17.94 11.2087C16.8521 9.93636 13.6508 6.60025 9.99959 6.60025C6.34841 6.60025 3.1482 9.93523 2.05989 11.2079Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 3.59436H9.18678V1.25031H10.8125V3.59436Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15094 4.66845L4.29283 2.48725L5.80552 1.89178L6.66371 4.07307L5.15094 4.66845Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.78871 7.14621L0.19165 5.43079L1.38132 4.32263L2.97838 6.03813L1.78871 7.14621Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8483 4.66845L13.3356 4.07307L14.1938 1.89178L15.7065 2.48725L14.8483 4.66845Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2106 7.14621L17.021 6.03805L18.618 4.32263L19.8077 5.43079L18.2106 7.14621Z",
    fill: "#2D3232"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: -0.9,
    x2: 21.8519,
    y2: -0.9,
    transform: "matrix(0.810612 -0.585583 0.585398 0.810746 1.62498 18.1294)",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEye);
export default __webpack_public_path__ + "static/media/hideEye.7cb41cdb106169dc744fdca46ea5739f.svg";
export { ForwardRef as ReactComponent };